<template>
  <div class="deposit-order-details">
    <div class="deposit-order-detail-group">
      <DepositOrderDescription label="订单类型" :value="orderTypeString" />
      <DepositOrderDescription
        type="amount"
        label="订单金额"
        :value="order.amount"
      />
      <DepositOrderDescription
        label="订单编号"
        :value="order.orderNo"
        copiable
      />
      <DepositOrderDescription
        type="time"
        label="下单时间"
        :value="order.submitTime || order.createdDate"
        time-format="YYYY-MM-DD HH:mm:ss"
      />
      <DepositOrderDescription
        v-if="order.status > 10 && order.payMethod"
        label="支付方式"
        :value="payTypeString"
      />
      <DepositOrderDescription
        v-if="order.status > 10 && order.payTime"
        type="time"
        label="支付时间"
        :value="order.payTime"
        time-format="YYYY-MM-DD HH:mm:ss"
      />
      <DepositOrderDescription
        :label="runInWxWork ? '备注 (客人可见)：' : '备注：'"
        :value="order.remark"
      />
      <DepositOrderDescription
        v-if="runInWxWork"
        label="备注 (仅内部可见)"
        :value="order.innerRemark"
      />
    </div>
    <div
      v-if="runInWxWork && [60, 80].includes(order.status) && order.posNumber"
      class="deposit-order-detail-group"
    >
      <DepositOrderDescription
        label="POS单号"
        :value="order.posNumber"
        :editable="canModifyPosNumber"
        copiable
        @edit="$emit('modifyposnumber')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DepositOrderDescription from "../widgets/DepositOrderDescription.vue";
import { getEnumMap } from "@/api";

export default {
  components: { DepositOrderDescription },
  props: {
    order: Object,
    isCreator: Boolean,
    refundStatus: Object,
  },
  data() {
    return { inited: false, orderTypeMap: {}, payTypeMap: {} };
  },
  computed: {
    ...mapGetters(["runInWxWork"]),
    canModifyPosNumber() {
      return (
        this.isCreator &&
        !this.refundStatus.isRefundingOrDone &&
        (this.order.status === 60 || this.order.status === 80)
      );
    },
    orderTypeString() {
      return this.inited ? this.orderTypeMap[this.order.type] : "";
    },
    payTypeString() {
      return this.inited ? this.payTypeMap[this.order.payType] : "";
    },
  },
  mounted() {
    Promise.all([getEnumMap("OrderTypeEnum"), getEnumMap("PayTypeEnum")]).then(
      ([orderTypeMap, payTypeMap]) => {
        this.orderTypeMap = orderTypeMap;
        this.payTypeMap = payTypeMap;
        this.inited = true;
      }
    );
  },
};
</script>

<style lang="less" scoped>
.deposit-order-detail-group {
  padding: 0 20/20rem;
  border-bottom: 10/20rem solid #f7f7f7;
}
</style>
